import { render, staticRenderFns } from "./StatusCriterions.vue?vue&type=template&id=ec838680&"
import script from "./StatusCriterions.vue?vue&type=script&lang=js&"
export * from "./StatusCriterions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports